import ArtDirectionImage, {
  type ArtDirectionImageProps,
} from '@/app/components/Image/ArtDirectionImage';

export interface PopFinishesCarouselSlideProps {
  readonly image: ArtDirectionImageProps;
}

const PopFinishesCarouselSlide = ({ image }: PopFinishesCarouselSlideProps) => {
  return (
    <div
      className="relative h-[540px] md:aspect-3/2 md:h-auto lg:aspect-2/1"
      data-cy="pop-finishes-carousel-slide"
    >
      <ArtDirectionImage
        className="object-cover"
        draggable={false}
        fill
        {...image}
      />
    </div>
  );
};

export default PopFinishesCarouselSlide;
